import useAuthenticatedQuery from "./useAuthenticatedQuery";

const useGetOrganizationDetails = () => {
  const {
    data: organizationDetails,
    isLoading: organizationDetailsLoading,
    error: organizationDetailsError,
    refetch: refetchOrganizationDetails,
  } = useAuthenticatedQuery(
    ["organizationDetails"],
    "/api/v1/organizations/my/details",
    {
      staleTime: 5 * 60 * 1000, // Cache for 5 minutes
      cacheTime: 10 * 60 * 1000, // Keep in cache for 10 minutes
      retry: 2,
      refetchOnWindowFocus: false,
      refetchOnMount: "always", // Always fetch fresh data when component mounts
    }
  );

  return {
    organizationDetails,
    organizationDetailsLoading,
    organizationDetailsError,
    refetchOrganizationDetails,
  };
};

export default useGetOrganizationDetails;
